import { render, staticRenderFns } from "./orgInfo.vue?vue&type=template&id=a3642676&scoped=true"
import script from "./orgInfo.vue?vue&type=script&lang=js"
export * from "./orgInfo.vue?vue&type=script&lang=js"
import style0 from "./orgInfo.vue?vue&type=style&index=0&id=a3642676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3642676",
  null
  
)

export default component.exports